import styled from 'styled-components'
import { Colors, Typography } from 'cio-design-library/design-tokens'
import { Media } from 'builder/styles/media'

export const Image = styled.img`
  max-width: 412px;

  ${Media.Phone`
    max-width: 300px;
  `}
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`

export const Description = styled.div`
  ${Typography.sizes.Body};
  font-weight: ${Typography.weights.medium};
  color: ${Colors.Neutral90};
  display: flex;
  align-items: center;
  gap: 4px;
`
